import SliceExpandableCardsCollectionCardView from '@utmb/types/view/SliceExpandableCardsCollectionCardView';
import { ReactElement } from 'react';
import { Image } from '@utmb/design-system/image/Image';
import styles from './expandable-card-title-over-picture.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { getColorStyle } from '@utmb/utils/colors';
import { useGlobal } from '@utmb/contexts/GlobalContext';
import { parseMarkdown } from '@utmb/utils/markdown';
import { ColorTypesEnum } from '@utmb/types/colors';
import { useTranslation } from 'next-i18next';

export const ExpandableCardTitleOverPicture = (props: SliceExpandableCardsCollectionCardView): ReactElement => {
    const { title, summary, picture, color } = props;
    const { t } = useTranslation('common');

    const {
        global: {
            event: { primaryColorIsDark },
        },
    } = useGlobal();

    return (
        <div className={styles.cardTitleOverPicture}>
            <div className={styles.header} style={{ background: color ? getColorStyle(color) : 'unset' }}>
                <Font.FuturaHeavy className={styles.title} color={getColorStyle(ColorTypesEnum.WHITE)}>
                    {title}
                </Font.FuturaHeavy>
                <div className={styles.background}>
                    {picture ? <Image className={styles.picture} layout="fill" objectFit="cover" image={picture} maxWidth={500} /> : null}
                </div>
            </div>
            <div className={styles.content}>
                {summary && (
                    <Font.FuturaBook className={styles.summary} mobile="14" as="div">
                        <div
                            className={`markdown ${primaryColorIsDark ? 'primaryColorIsDark' : ''}`}
                            dangerouslySetInnerHTML={{ __html: parseMarkdown(summary) }}
                        />
                    </Font.FuturaBook>
                )}
                <Font.FuturaBook mobile="14" className="font-underline -stretched-link">
                    {t('promotionSlider.seeMore')}
                </Font.FuturaBook>
            </div>
        </div>
    );
};
